import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { api } from '../services/api';

export default function PartnerInventory() {
  const { dealerId } = useParams();
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadInventory();
  }, [dealerId]);

  const loadInventory = async () => {
    try {
      const data = await api.getDealerInventory(dealerId);
      setVehicles(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="loading">Loading inventory...</div>;

  return (
    <div>
      <div style={{ marginBottom: '20px' }}>
        <Link to="/partner">&larr; Back to Dashboard</Link>
      </div>

      <h2>Dealer Inventory</h2>
      <p>{vehicles.length} vehicles available</p>

      {error && <div className="alert alert-error">{error}</div>}

      {vehicles.length === 0 ? (
        <div className="card">
          <p>No vehicles found in this dealer's inventory.</p>
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '20px' }}>
          {vehicles.map(vehicle => (
            <div key={vehicle.id} className="card">
              <h4>{vehicle.year} {vehicle.make} {vehicle.model}</h4>
              {vehicle.trim && <p style={{ color: '#666', marginBottom: '10px' }}>{vehicle.trim}</p>}
              <div style={{ fontSize: '14px' }}>
                <p><strong>VIN:</strong> {vehicle.vin}</p>
                <p><strong>Stock #:</strong> {vehicle.stock_number}</p>
                <p><strong>Mileage:</strong> {vehicle.mileage?.toLocaleString() || 'N/A'}</p>
                <p><strong>Price:</strong> ${vehicle.asking_price?.toLocaleString() || 'Call'}</p>
                <p><strong>Color:</strong> {vehicle.exterior_color}</p>
                <p><strong>Transmission:</strong> {vehicle.transmission}</p>
                <p><strong>Drivetrain:</strong> {vehicle.drivetrain}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
